import React, { useState, useEffect } from "react";

import { Row, Col, Modal } from "react-bootstrap";

import { useTopicContext } from "../../../contexts/TopicContext";
import { useTeamTopicContext } from "../../../contexts/TeamTopicContext";
import Select from "react-select";

import Tooltip from "../../ui/Tooltip";

export default function ChooseTopic() {
  const { dispatch, actions, state } = useTopicContext();
  const {
    dispatch: dispatchTeam,
    actions: actionsTeam,
    state: stateTeam,
  } = useTeamTopicContext();

  const [topic, setTopic] = useState(null);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    actions.loadTopics(dispatch);
  }, []);

  const onTopicChange = (value, action) => {
    setTopic(value.value);
  };

  const assignTopic = () => {
    if (topic != null) {
      setLoader(true);
      actionsTeam.assignTopic(dispatchTeam, stateTeam.team, topic, () => {
        actionsTeam.loadTopics(dispatchTeam, stateTeam.team);
        setLoader(false);
        toastr["info"]("Topic was successfully assigned.");
      });
    }
  };

  return (
    <>
      <p>Select and add the Topic to the Team.</p>
      <Row>
        <Col md={8}>
          <Select
            onChange={onTopicChange}
            placeholder="Select Topic"
            options={(state.topics || [])
              .filter((item) => item.attributes.topic_category_type == "custom")
              .map((item) => {
                return {
                  label: item.attributes.title,
                  value: item.id,
                };
              })}
          />
        </Col>
        <Col md={4}>
          <a
            data-tip="Please, select a Topic from the list and click the button."
            onClick={assignTopic}
            className="btn btn-green w-150"
          >
            Add To Team
          </a>
        </Col>
      </Row>
      <Tooltip />
      <Modal className="student inmodal auto without-overflow" show={loader}>
        <Modal.Body className="text-center">
          <i className="fa fa-spinner fa-spin" style={{ fontSize: "4em" }}></i>
          <h3>Please wait ...</h3>
        </Modal.Body>
      </Modal>
    </>
  );
}
